import { useEffect } from "react";
import i18n from "../../../../../../constants/i18n";
import ET3Circle from "../../../../../../core/et3-circle";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import { isPositiveNumber } from "et3-type-guards";
import getKhattabat102Store from "../../../../../../stores/khattabat-stores/102-stores";

const OneOTwoQuality = withLiteObserverAndTheme<{
  oneOTwoConversationId: string;
}>((props) => {
  const { theme, oneOTwoConversationId } = props;
  const { colors } = theme;
  const {
    manualIsQuality,
    shouldSetOneOTwoToQuality,
    toggleOneTwoQualityState
  } = getKhattabat102Store(oneOTwoConversationId);
  useEffect(() => {
    shouldSetOneOTwoToQuality();
  });
  const isSelected = isPositiveNumber(manualIsQuality.get());

  return (
    <ET3Div
      width={0}
      height={45}
      alignItems={"center"}
      fDirection={"row"}
      style={{ width: "auto" }}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Circle
        size={20}
        style={{
          border: `2px solid ${colors.all.dimGray}`,
          backgroundColor: isSelected
            ? colors.all.green
            : colors.all.transparent,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer"
        }}
        color={""}
        withShadow={true}
        onClick={async () => {
          await toggleOneTwoQualityState({
            isAuto: 0
          });
        }}
      ></ET3Circle>
      <Et3Margin top={0} bottom={0} left={5} right={5} />
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("QUALITY")}
        style={{}}
        color={colors.all.black}
      />
    </ET3Div>
  );
});

export default OneOTwoQuality;
